<template>
  <div>
    <vueper-slides
      id="merchandises"
      class="no-shadow"
      @ready="doResize"
      :slideMultiple="true"
      :arrowsOutside="true"
      :bulletsOutside="false"
      :dragging-distance="50"
      :visibleSlides="3"
      :gap="2"
      :fixedHeight="height"
      :breakpoints="{
        1200: {
          visibleSlides: 2,
        },
        // 990 and below is mobile view without sidebar menu
        990: {
          visibleSlides: 3,
        },
        800: {
          visibleSlides: 2,
        },
        580: {
          visibleSlides: 1,
        }
      }"
    >
            <template #arrow-left class="left">
              <i class='arrows far fa-chevron-left' />
            </template>

            <template #arrow-right class="right">
              <i class='arrows far fa-chevron-right'/>
            </template>
      <vueper-slide v-for="item in availableMerchandise" :key="item._id">
        <template v-slot:content>
          <div ref="sliderItems" :style="{ minHeight: stretch ? '100%' : 0 }" style="padding: 5px; display: flex; align-items: stretch">
            <md-card class="md-card-plain">
              <md-card-content style="overflow-y: auto; flex-grow: 1; display: flex; flex-direction: column; justify-content: space-between">
                <div>
                  <img v-if="item.image" :src="item.image" @load="doResize">
                  <span><b>{{item.title}}</b></span>
                  <span v-html="item.description"></span>

                </div>

                <div style="text-align: left">
                  <dynamic-form
                    :ref="'options-' + item._id"
                    v-if="hasOptions(item)"
                    :formFields="item.options"
                    style="max-width: 600px"
                    :hideSubmit="true"
                  />

                  <dynamic-form
                    :ref="'donation-options-' + item._id"
                    v-if="hasDonationOptions(item)"
                    :formFields="donationForm"
                    style="max-width: 600px"
                    :hideSubmit="true"
                  />
                </div>
              </md-card-content>

              <md-card-actions md-alignment="space-between">
                <div class="price">
                    <span class="md-title">{{item.price === 0 ? '' : formatCurrency(item.price, currency)}}</span><br>
                    <span v-if="item.shippingWeight" class="md-caption">zzgl. Versand</span>
                </div>
                <div class="stats">
                  <md-button @click="onSelect(item)" class="md-success md-round">Hinzufügen</md-button>
                </div>
              </md-card-actions>
            </md-card>
          </div>
        </template>
      </vueper-slide>
    </vueper-slides>
  </div>
</template>

<script>
import DynamicForm from '@/components/DynamicForm/DynamicForm';
import currencyUtils from '@/utils/currency';
import debounce from '@/utils/debounce';

export default {
  props: ['availableMerchandise', 'currency', 'donationForm'],
  components: {
    DynamicForm
  },
  data() {
    return {
      doResize: debounce(() => {
        this.stretch = false;
        this.$nextTick(() => {
          if (this.$refs.sliderItems) {
            this.height = Math.max(...(this.$refs.sliderItems.map(el => el.getBoundingClientRect().height))) + 'px';
          }
          this.stretch = true;
        });
      }, 600),
      height: '0px',
      stretch: false,
    };
  },
  mounted() {
    this.doResize();
  },
  created() {
    window.addEventListener("resize", this.doResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.doResize);
  },
  watch: {
    availableMerchandise: 'doResize'
  },
  methods: {
    ...currencyUtils,
    hasOptions: function(item) {
      return !!(item.options && item.options.length);
    },
    hasDonationOptions: function(item) {
      return !!(item.donationAmount && this.donationForm && this.donationForm.length);
    },
    async onSelect(item) {
      let selectedOptions;
      let donationFormData;

      if (this.hasOptions(item)) {
        const form = this.$refs['options-' + item._id][0];
        selectedOptions = await form.submit();
        if (!selectedOptions) {
          return;
        }
        form.reset();
      }
      if (this.hasDonationOptions(item)) {
        const donationForm = this.$refs['donation-options-' + item._id][0];
        donationFormData = await donationForm.submit();
        if (!donationFormData) {
          return;
        }
        donationForm.reset();
      }

      this.$emit('add-cart-item', { merchandise: item, selectedOptions, donationFormData });
    },
  }
};
</script>

<style lang="scss" scoped>
#merchandises {
  .arrows {
    color: black;
    font-size: 3em;
  }
}
@media (max-width: 768px) {
  .md-card-plain {
    margin: 0;
  }
}
</style>
